class ImageLoader {
  key = "image";

  async load(assetsPath) {
    return new Promise((resolve, reject) => {
      const sourceElement = document.createElement("img");
      sourceElement.setAttribute("crossorigin", "anonymous");
      sourceElement.setAttribute("src", assetsPath);

      const handleLoad = () => {
        sourceElement.removeEventListener("load", handleLoad);
        resolve({
          content: sourceElement,
          representation: {
            naturalWidth: sourceElement.naturalWidth,
            naturalHeight: sourceElement.naturalHeight,
          },
        });
      };
      sourceElement.addEventListener("load", handleLoad);
      sourceElement.addEventListener("error", reject);
    });
  }
}

const imageLoader = new ImageLoader();
export { imageLoader, ImageLoader };
